/**
 *
 * @author Jun.liu
 */

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const node = document.createElement('script')
    node.setAttribute('async', 'async')
    let timeID
    const supportLoad = 'onload' in node
    const onEvent = supportLoad ? 'onload' : 'onreadystatechange'
    node[onEvent] = function onLoad() {
      if (!supportLoad && !timeID && /complete|loaded/.test(node.readyState)) {
        timeID = setTimeout(onLoad)
        return
      }
      if (supportLoad || timeID) {
        clearTimeout(timeID)
        resolve(null, node)
      }
    }
    document.head.insertBefore(node, document.head.firstChild)
    node.src = src
    node.onerror = function(e) {
      reject(e)
    }
  })
}

const loaded = {}

export async function afterRouterCreate(route) {
  route.beforeEach(async (to, from, next) => {
    const pathArray = to.path.split('/')
    if (pathArray[1] !== 'remote') {
      next()
      return
    }

    const appName = pathArray[2]

    const camelAppName = (appName || '').replace(/-(\w)/g, (all, letter) => {
      return letter.toUpperCase()
    })

    const entryUrl = `${location.origin}/${appName}/entry.js`

    if (loaded[entryUrl]) {
      next()
      return
    }

    await loadScript(entryUrl)
    loaded[entryUrl] = true
    const routes = await window[camelAppName].get('routes').then(res => res())
    routes.default.forEach(it => {
      it.path = `/remote/${appName}` + it.path
    })
    route.addRoutes(routes.default)
    next()
    route.replace(to.path)
  })
}
